import { render, staticRenderFns } from "./authenticated.vue?vue&type=template&id=063f10c0&scoped=true&"
import script from "./authenticated.vue?vue&type=script&lang=js&"
export * from "./authenticated.vue?vue&type=script&lang=js&"
import style0 from "./authenticated.vue?vue&type=style&index=0&id=063f10c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f10c0",
  null
  
)

export default component.exports